import { Button } from "@/components/ui/button"
import { Loader2 } from "lucide-react"

export const PdfHeaderActionButton = ({
  onClick,
  disabled,
  title,
  isLoading,
  icon,
}: {
  onClick: () => void
  disabled: boolean
  title: string
  isLoading: boolean | undefined
  icon: React.ElementType
}) => {
  const Icon = icon
  return (
    <Button onClick={onClick} disabled={disabled} variant={"outline"}>
      {isLoading ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : (
        <Icon size={16} />
      )}
      {title}
    </Button>
  )
}
